var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.559,
    height: 19.115,
    viewBox: "0 0 22.559 19.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.894,
    y1: 0.706,
    x2: 0.147,
    y2: 0.193,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "camera",
    d: "M19.034,42.55H17.023l-.759-1.518a3.506,3.506,0,0,0-3.153-1.948H9.447a3.506,3.506,0,0,0-3.153,1.948L5.536,42.55H3.525A3.529,3.529,0,0,0,0,46.075v8.6A3.529,3.529,0,0,0,3.525,58.2H19.034a3.529,3.529,0,0,0,3.525-3.525v-8.6A3.529,3.529,0,0,0,19.034,42.55ZM20.8,54.674a1.764,1.764,0,0,1-1.762,1.762H3.525a1.764,1.764,0,0,1-1.762-1.762v-8.6a1.764,1.764,0,0,1,1.762-1.762H6.08a.881.881,0,0,0,.788-.487l1-2a1.753,1.753,0,0,1,1.576-.974h3.664a1.753,1.753,0,0,1,1.576.974l1,2a.881.881,0,0,0,.788.487h2.555A1.764,1.764,0,0,1,20.8,46.075Zm-9.517-9.539a4.347,4.347,0,1,0,4.347,4.347A4.352,4.352,0,0,0,11.279,45.135Zm0,6.932a2.585,2.585,0,1,1,2.585-2.585A2.588,2.588,0,0,1,11.279,52.067Z",
    transform: "translate(0 -39.084)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e7dea8086d0bee74933962634149a8f5.svg";
export { ForwardRef as ReactComponent };